import React from 'react';
import _ from 'lodash/fp';
import moment from 'moment';
import { appContext } from '../../util/decorators';
import viaplayLogo from '../../../assets/viaplay-logo.png';
import LiveStreamListing from './LiveStreamListing.jsx';
import cx from 'classnames';
import viaplayProvider from '../../provider/viaplay';
import Loader from '../Loader';

@appContext
export default class ViaplayLiveFeed extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { selectedFeed: 'liveStreams', loading: false };
  }

  getSubtitle(stream) {
    const subtitle = stream.sportType ? stream.sportType : stream.league;
    return stream.sportType && stream.sportsGender ? `${subtitle} ${stream.sportsGender}` : subtitle;
  }

  componentDidMount() {
    if (window.localStorage.highlightsViaplayFeedSelected === 'true') this.onHighlightLiveStreamSelect();
  }

  onLiveStreamSelect() {
    this.setState({selectedFeed: 'liveStreams'});
    window.localStorage.highlightsViaplayFeedSelected = 'false';
  }

  onHighlightLiveStreamSelect() {
    const { country, language } = this.props;
    this.setState({loading: true, selectedFeed: 'highlightsLiveStreams'});
    viaplayProvider({country, language, config: { onlyHighlights: true }}).then(result => {
      this.setState({highlightsLiveStreams: result, loading: false});
    });
    window.localStorage.highlightsViaplayFeedSelected = 'true';
  }

  render() {
    const { t, serverTime } = this.context.app;
    const { selectedFeed, highlightsLiveStreams, loading } = this.state;

    const streams = _.flow(
      _.filter(stream => serverTime().diff(stream.utcEndDateTime) < 0),
      _.take(10),
      _.map(stream => ({
        title: stream.title,
        subTitle: this.getSubtitle(stream),
        picture: stream.images.landscape.url,
        url: stream.url,
        startTime: stream.utcStartDateTime ? moment(stream.utcStartDateTime).locale(this.props.language) : null,
        endTime: stream.utcEndDateTime ? moment(stream.utcEndDateTime) : null,
        league: stream.league,
      })),
    )(selectedFeed === 'liveStreams' ? this.props.liveStreams : highlightsLiveStreams || []);

    return (
      <div>
        <div className="viaplay-feed">
          <header>
            <img src={viaplayLogo} alt="viaplay-logo" />
          </header>

          <div className="stream-select">
            <button className={cx({selected: selectedFeed === 'liveStreams'})} onClick={() => this.onLiveStreamSelect()}>
              {t('ViaplayLiveFeed.all_streams')}
            </button>
            <button className={cx({selected: selectedFeed === 'highlightsLiveStreams'})} onClick={() => this.onHighlightLiveStreamSelect()}>
              {t('ViaplayLiveFeed.highlight_streams')}
            </button>
          </div>

          { loading ? <Loader/> : <LiveStreamListing liveStreams={streams} /> }

          <div className="button-wrapper">
            <p>{t('ViaplayLiveFeed.text')}</p>
            <a className="btn-purchase" href={`https://checkout.viaplay.${this.props.country}`} target="_blank">{t('ViaplayLiveFeed.button')}</a>
            <a className="viaplay-link" target="_blank" href={t('ViaplayLiveFeed.link')}>{t('ViaplayLiveFeed.linkText')}</a>
          </div>
        </div>

	   
      </div>
      
    );
  }
}

ViaplayLiveFeed.propTypes = {
  liveStreams: React.PropTypes.array,
  language: React.PropTypes.string,
  country: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/Sidebar/ViaplayLiveFeed.jsx